import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import { Platform } from 'quasar'

export default async ({ app, store, router }) => {
	Sentry.init({
		app,
		ignoreErrors: ignoreErrors,
		dsn: process.env.DSN_SENTRY,
		release: process.env.APP_VERSION,
		initialScope: (scope) => {
			const id = store.getters['common/id']
			scope.setTags({
				idUser: id ? id : 'none',
				isCap: `${!!Platform.is.capacitor}`,
			})
			return scope
		},
		integrations: [
			new BrowserTracing({
				routingInstrumentation: Sentry.vueRouterInstrumentation(router),
				tracePropagationTargets: ['localhost', process.env.SITE_URL, /^\//],
			}),
		],
		debug: false,
		tracesSampleRate: 0,
		tracingOptions: {
			trackComponents: true,
		},
		// Vue specific
		logErrors: true,
		attachProps: true,
		attachStacktrace: true,
	})
}

const ignoreErrors = [
	/^16$/,
	/^Load failed$/,
	/{*Load failed*/,
	/{*16*/,
	/{*ResizeObserver*/,
	/{*getBoundingClientRect*/,
	/{*play()*/,
	/{*CollectionReference*/,
	/{*UnhandledRejection*/,
	/{*Navigating to current location*/,
	/{*Navigation cancelled from*/,
	/{*Redirected when going from*/,
	/{*Avoided redundant navigation to current location*/,
	/{*Loading chunk*/,
	/{*Error: Loading CSS*/,
	/{*ChunkLoadError*/,
	/{*isTrusted*/,
	/{*INTERNAL ASSERTION FAILED*/,
	/{*Error: Fail to load image*/,
	/{*0*/,
	/{*fullscreen error*/,
	/{*Permissions check failed*/,
	/{*ResizeObserver loop completed with*/,
	/{*evaluating 'window.matchMedia("(orientation: portrait)").matches'*/,
	/{*Failed to execute 'getComputedStyle' on 'Window': parameter 1*/,
	/{*Esgotou-se o tempo limite da solicitação.*/,
	/{*A conexão de rede foi perdida.*/,
	/{*Failed to read the 'buffered' property from 'SourceBuffer'*/,
	/{*Non-Error exception captured with keys: currentTarget, detail, isTrusted, target*/,
	/{*null is not an object (evaluating 'window.matchMedia("(orientation: portrait)").matches')*/,
	/{*null is not an object (evaluating 'this.elements.wrapper')*/,
	'Large Render Blocking Asset',
	'/js/vendor',
	'ResizeObserver loop limit exceeded',
	"Cannot read property 'getBoundingClientRect' of undefined",
	'Missing or insufficient permissions.',
	"undefined is not an object (evaluating 'this.$refs.scroller.getBoundingClientRect')",
	'The play() request was interrupted by a call to pause(). https://goo.gl/LdLk22',
	'No error message',
	'Unexpected token <',
	'Function CollectionReference.doc() requires its first argument to be of type non-empty string, but it was: ""',
	'Network Error',
	"Unexpected token '<'",
	"expected expression, got '<'",
	'The operation was aborted.',
	'"Timeout"',
	'Large Render Blocking Asset',
	'Timeout',
	'Quota exceeded.',
	'Failed to fetch',
	'Non-Error promise rejection captured with keys: [object has no keys]',
	"InvalidStateError: Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing.",
	'Request failed with status code 500',
	'Non-Error promise rejection captured with value: Timeout',
	'Properties can only be defined on Objects.',
	'Falha ao buscar',
	'window.zE is not a function',
	'undefined',
	'Zendesk is not defined',
	"Object doesn't support property or method 'closest'",
	"Cannot read property 'uid' of null",
	"Cannot read property 'dispose' of null",
]
